export default __webpack_public_path__ + "static/newspaper-9048c7494e4f9bd46a2835fc9c3b0bf3.png";